var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.id == null
        ? _c(
            "div",
            { staticClass: "breadcrumb-layout" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("询盘管理")
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("新增询盘")])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "dealInqryVoucherForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.dealInqryVoucher,
            rules: _vm.checkDealInqryVoucher
          }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("询盘名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入" },
                        model: {
                          value: _vm.dealInqryVoucher.title,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "title", $$v)
                          },
                          expression: "dealInqryVoucher.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("交易类型")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "resource" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.changeTradeType },
                          model: {
                            value: _vm.dealInqryVoucher.tradeType,
                            callback: function($$v) {
                              _vm.$set(_vm.dealInqryVoucher, "tradeType", $$v)
                            },
                            expression: "dealInqryVoucher.tradeType"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "radio mr10",
                              attrs: { label: _vm.tradeTypeGoodsEnum.value }
                            },
                            [_vm._v(_vm._s(_vm.tradeTypeGoodsEnum.text))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticClass: "radio",
                              attrs: { label: _vm.tradeTypeServcEnum.value }
                            },
                            [_vm._v(_vm._s(_vm.tradeTypeServcEnum.text))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("询盘方式")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "resource" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.changeDirected },
                          model: {
                            value: _vm.dealInqryVoucher.directed,
                            callback: function($$v) {
                              _vm.$set(_vm.dealInqryVoucher, "directed", $$v)
                            },
                            expression: "dealInqryVoucher.directed"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "radio mr10",
                              attrs: { label: false }
                            },
                            [_vm._v("公开询盘")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: true } },
                            [_vm._v("定向询盘")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dealInqryVoucher.directed == true
                        ? _c(
                            "a",
                            {
                              staticClass: "ml10 swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.showCallbidTargetsDialog()
                                }
                              }
                            },
                            [_vm._v("选择")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group center",
                class: { "display-none": !_vm.dealInqryVoucher.directed }
              },
              [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("询盘商户")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-4x" },
                  _vm._l(_vm.dealInqryVoucher.dealInqryMerchtList, function(
                    dealInqryMercht
                  ) {
                    return _c("div", { staticClass: "value deletable" }, [
                      _c("span", [
                        _vm._v(_vm._s(dealInqryMercht.merchantName))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "icon iconfont icon-error",
                        on: {
                          click: function($event) {
                            _vm.removeMerchant(dealInqryMercht.merchantId)
                          }
                        }
                      })
                    ])
                  })
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("是否直接审核")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "auditFlag" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.dealInqryVoucher.auditFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.dealInqryVoucher, "auditFlag", $$v)
                            },
                            expression: "dealInqryVoucher.auditFlag"
                          }
                        },
                        [_vm._v("是")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("截止日期")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "expireDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "picker-options": _vm.pickerOptions0
                        },
                        model: {
                          value: _vm.dealInqryVoucher.expireDate,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "expireDate", $$v)
                          },
                          expression: "dealInqryVoucher.expireDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("联系人")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "contactName" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入" },
                        model: {
                          value: _vm.dealInqryVoucher.contactName,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "contactName", $$v)
                          },
                          expression: "dealInqryVoucher.contactName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("联系电话")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "contactTel" } },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入" },
                        model: {
                          value: _vm.dealInqryVoucher.contactTel,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "contactTel", $$v)
                          },
                          expression: "dealInqryVoucher.contactTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("添加地址")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "deliverStreet" } },
                    [
                      _c("swb-region", {
                        ref: "swb_region",
                        attrs: { item: _vm.dealInqryVoucher },
                        on: {
                          "notity-change": function($event) {
                            _vm.notityChange($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { "margin-top": "3px" },
                        attrs: { type: "text", placeholder: "请输入详细地址" },
                        model: {
                          value: _vm.dealInqryVoucher.deliverStreet,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "deliverStreet", $$v)
                          },
                          expression: "dealInqryVoucher.deliverStreet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("询盘标签")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticClass: "width-1x",
                        attrs: { type: "text", placeholder: "请输入标签内容" },
                        model: {
                          value: _vm.dealInqryVoucher.tag,
                          callback: function($$v) {
                            _vm.$set(_vm.dealInqryVoucher, "tag", $$v)
                          },
                          expression: "dealInqryVoucher.tag"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("描述(最大3000)")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _vm.id == null || _vm.content != null
                    ? _c("swb-ck-editor", {
                        ref: "theCkEditor",
                        attrs: {
                          content: _vm.content,
                          imageXtHandler: _vm.imageXtHandler
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.id == null
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "button",
                  {
                    staticClass: "swb-btn swb-btn-small mr10",
                    on: { click: _vm.submitDealInqryVoucher }
                  },
                  [_vm._v("确定")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "swb-btn swb-btn-small swb-btn-primary",
                    on: {
                      click: function($event) {
                        _vm.restDealInqryVoucherList()
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3924a49a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3924a49a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/InqryVoucher/DealInqryVoucherSave.vue
// module id = 3275
// module chunks = 0